import styled from "styled-components";

export const StyledDropdown = styled.ul`
  ${({ theme, isOpen }) => `
    width: 11.25rem;
    top: 100%;
    left: 0;
    z-index: ${theme.zIndex.navigationDropdown};
    padding: 0.5rem 0;
    margin-top: 2px;
    position: absolute;
    display: ${isOpen ? "block" : "none"};
    background: ${theme.colors.white};
    box-shadow: ${theme.boxshadow.sm.base};
  `}
`;
